/* global axios */
import ApiClient from '../ApiClient';

class AilabAssistant extends ApiClient {
  constructor() {
    super('ailab/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  create(payload = {}) {
    // Backend expects `{ assistant: {...} }`. Keep backward-compat with callers
    // passing the assistant attributes directly.
    const body = payload?.assistant ? payload : { assistant: payload };
    return axios.post(this.url, body);
  }

  update(id, payload = {}) {
    // Backend expects `{ assistant: {...} }`. Keep backward-compat with callers
    // passing the assistant attributes directly.
    const body = payload?.assistant ? payload : { assistant: payload };
    return axios.patch(`${this.url}/${id}`, body);
  }

  playground({
    assistantId,
    messageContent,
    messageHistory,
    imageUrl,
    imageFile,
  }) {
    // If an image file is provided, use multipart upload (Playground image test for AI gamer).
    if (imageFile) {
      const formData = new FormData();
      formData.append('message_content', messageContent || '');
      formData.append('message_history', JSON.stringify(messageHistory || []));
      if (imageUrl) formData.append('image_url', imageUrl);
      formData.append('image_file', imageFile);
      return axios.post(`${this.url}/${assistantId}/playground`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
      image_url: imageUrl,
    });
  }

  clone({ assistantId, name, sidebarKey, blank } = {}) {
    return axios.post(`${this.url}/${assistantId}/clone`, {
      name,
      sidebar_key: sidebarKey,
      blank,
    });
  }
}

export default new AilabAssistant();
